export const HOME_PAGE_ROUTE = "/ai-writer";
export const BRIEFING_PAGE_ROUTE = "/briefing";
export const BLANK_WORKSPACE_PAGE_ROUTE = "/blank-workspace";
export const STAT = "/student-statistics";